export class SearchView<T> {
    public items: Array<T>;
    public total: number;
    public continuationToken: string;

    constructor(items: Array<T>, total: number) {
        this.items = items;
        this.total = total;
    }

    public static empty<T>(): SearchView<T> {
        return new SearchView<T>([], 0);
    }
}
